import React, { FC, Fragment } from 'react';
import { Organization } from 'models/organization';
import { LinkedOrganization, User } from 'models/user';
import { TableCell, TableRow, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ActiveIndicator from 'components/users/shared/active-indicator/active-indicator.component';
import { resolveUserOrganization } from 'utils/user-organization';

type DentistItemProps = {
    dentist: User;
    onUpdateDentist: (dentist: User) => void;
    onLoginClick?: (user: User) => void;
};

const DentistItem: FC<DentistItemProps> = ({ dentist, onUpdateDentist, onLoginClick }: DentistItemProps) => {
    const { t: translate } = useTranslation('common');
    // Derived rather than held in state — see technicians-item for why.
    const userOrganization = resolveUserOrganization(dentist);

    const handleLoginClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation();
        if (onLoginClick) {
            onLoginClick(dentist);
        }
    };

    return (
        <Fragment>
            <TableRow
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => onUpdateDentist(Object.assign({}, dentist, userOrganization))}
            >
                <Fragment>
                    <TableCell sx={{ width: 10 }} align="center">
                        <ActiveIndicator isActive={!!userOrganization?.active} />
                    </TableCell>
                    <TableCell sx={{ width: 300 }}>
                        {dentist.name.firstName} {dentist.name.lastName}
                    </TableCell>
                    <TableCell>{dentist.email}</TableCell>
                    <TableCell>{translate(userOrganization.role)}</TableCell>
                    {dentist.linkedOrganizations?.length > 1 ? (
                        <TableCell>
                            {dentist.linkedOrganizations
                                .map(
                                    (linkedOrganization: LinkedOrganization) =>
                                        (linkedOrganization.organization as Organization).name,
                                )
                                .join(', ')}
                        </TableCell>
                    ) : (
                        <TableCell>{(userOrganization.organization as Organization)?.name}</TableCell>
                    )}
                    <TableCell>
                        <Button onClick={handleLoginClick}>{translate('users:LOGIN')}</Button>
                    </TableCell>
                </Fragment>
            </TableRow>
        </Fragment>
    );
};

export default DentistItem;
